import { Injectable } from '@angular/core';

import { BetslipError, BetslipErrorSaved } from '../errors/betslip-error';

@Injectable({ providedIn: 'root' })
export default class ErrorsStateStorageService {
    toSavedState(betslipError: BetslipError): BetslipErrorSaved {
        return {
            ...betslipError,
        };
    }

    fromSavedState(saved: BetslipErrorSaved): BetslipError {
        return Object.assign(new BetslipError(), saved);
    }
}
